import { createBreakpoints } from '@mui/system';
var breakpoints = createBreakpoints({});
export var ListItemTextTheme = function (theme) {
    var _a;
    return ({
        defaultProps: {},
        styleOverrides: {
            root: {},
            primary: (_a = {
                    fontSize: theme.typography.body1.fontSize
                },
                _a[breakpoints.down('sm')] = {
                    fontSize: "0.813rem", //13
                },
                _a),
        },
    });
};
export default ListItemTextTheme;
//# sourceMappingURL=theme.js.map